// src/pages/FacebookServicePage.jsx
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import BASE_URL from '../../config';
import Cookies from 'js-cookie';

import { useDispatch } from 'react-redux';
import { setAuthRedirectPath } from '../../store/userSlice';

const FacebookServicePage = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    // Читаем state из URL (сохранённый redirect path)
    const stateFromUrl = searchParams.get('state') || '';

    if (code) {
      fetch(`${BASE_URL}/users/v1/auth/facebook/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
      })
        .then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Authorization error');
          }
          return response.json();
        })
        .then((data) => {
          Cookies.set('access_token', data.access, { sameSite: 'Strict', expires: 1 });
          Cookies.set('refresh_token', data.refresh, { sameSite: 'Strict', expires: 3 });

          // Читаем redirect path напрямую из sessionStorage (избегаем stale closure)
          const savedPath = sessionStorage.getItem('authRedirectPath');
          const target = savedPath || stateFromUrl || '/';
          console.log('[FacebookAuth] redirect target:', target, '| savedPath:', savedPath, '| stateFromUrl:', stateFromUrl);
          sessionStorage.removeItem('authRedirectPath');
          dispatch(setAuthRedirectPath(null));
          window.location.href = target;
        })
        .catch((error) => {
          console.error('Ошибка авторизации:', error);
          setError(error.message || 'Authorization failed');
        });
    } else {
      console.warn('Не найден параметр "code" в URL');
      setError('Authorization code not found');
    }
  }, [searchParams]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', padding: '40px 20px', textAlign: 'center' }}>
      {error ? (
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <h2 style={{ color: '#e74c3c', fontSize: '24px', marginBottom: '16px' }}>Authorization failed</h2>
          <p style={{ color: '#666', fontSize: '14px', wordBreak: 'break-word', lineHeight: '1.5' }}>{error}</p>
          <a href="/authorization" style={{ color: '#2F57BF', marginTop: '20px', display: 'inline-block', fontSize: '16px' }}>Try again</a>
        </div>
      ) : (
        <h2 style={{ fontSize: '24px' }}>Authorization processing via Facebook...</h2>
      )}
    </div>
  );
};

export default FacebookServicePage;